import type React from 'react';

import type { NavigationActionCommon } from '../../common/types';
import { isTeamsAppEnabled } from '../../common/utils/is-teams-app-enabled';
import { openInNewTab } from '../../common/utils/openInNewTab';
import { redirect } from '../../common/utils/redirect';

export const onNavigateBase =
	(href: string, config: NavigationActionCommon) =>
	(e?: React.MouseEvent | React.KeyboardEvent): void => {
		if (e) {
			e.preventDefault();
		}

		if (isTeamsAppEnabled(config)) {
			if (config.shouldOpenInSameTab) {
				redirect(href);
				return;
			}
			openInNewTab(href);
			return;
		} else {
			if (config.shouldOpenInSameTab) {
				if (config.push) {
					config.push(href);
					return;
				}
				redirect(href);
				return;
			} else {
				openInNewTab(href);
				return;
			}
		}
	};
